const chars = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/`;
export const alphabetByEncoding = Object.entries(chars).reduce((acc, [i, c]) => {
    acc[c] = Number(i);
    return acc;
}, {});
export const alphabetByValue = chars.split("");
export const bitsPerLetter = 6;
export const bitsPerByte = 8;
export const maxLetterValue = 0b111111;
